import React from 'react';
import { IconWrapper } from './Accordion.styles';
import { StyledIcon } from 'src/components/foundations/foundations.styles';

interface CollapseIconProps {
  customCollapseIconOpen?: React.ReactNode;
  customCollapseIconClosed?: React.ReactNode;
  open: boolean;
}

export const CollapseIcon = ({
  customCollapseIconOpen,
  customCollapseIconClosed,
  open,
}: CollapseIconProps) => {
  if (open && customCollapseIconOpen) {
    return <>{customCollapseIconOpen}</>;
  }

  if (!open && customCollapseIconClosed) {
    return <>{customCollapseIconClosed}</>;
  }

  return (
    <IconWrapper open={open}>
      <StyledIcon className={`uil uil-angle-down`} size="20px" />
    </IconWrapper>
  );
};
